import React from "react";
import ContentLoader from "react-content-loader";

const AddressesPlaceholder = () => {
  return (
    <div className="row">
      <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
        <ContentLoader viewBox="0 0 500 350" className="mb-3 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="350" />
        </ContentLoader>
      </div>
      <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
        <ContentLoader viewBox="0 0 500 350" className="mb-3 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="350" />
        </ContentLoader>
      </div>
      <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
        <ContentLoader viewBox="0 0 500 350" className="mb-3 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="350" />
        </ContentLoader>
      </div>
      <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
        <ContentLoader viewBox="0 0 500 350" className="mb-3 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="350" />
        </ContentLoader>
      </div>
    </div>
  );
};

export default AddressesPlaceholder;
